import { Pipe, PipeTransform } from '@angular/core';
/**
 * Translate a UserRole into a display name.
 */
@Pipe({
    name: 'excelSwap',
    pure: true
})
export class ExcelSwapPipe implements PipeTransform {

    transform(value: string) {
        // Currently, display name and value are the same. That could change though.
        //return UserRoleMap[value] || "Unknown/"+value;
        let result = value.toString().replace("Excel", "").trim();
        return result;
    }
}
